import { FlagBannerFold } from "@phosphor-icons/react";
import { clsx } from "clsx";

import RenderIf from "common/components/RenderIf";
import Alert from "common/components/ui/Alert";
import usePromotions from "common/datahooks/usePromotions";

import SettingsScrollContent from "../SettingsScrollContent";
import LifetimeLicenseSummary from "./LifetimeLicenseSummary";
import WorkspacesTable from "./WorkspacesTable";

import CheckIcon from "assets/icons/settings/check-icon.svg?react";

const PLAN_FEATURES = [
  "Easily connect accounts",
  "Unibox access",
  "Inbound & outbound",
  "3rd party integrations",
];

export default function LifetimeSeats() {
  const { ltdPromotion, appSumoPromotion } = usePromotions();
  const isLifetimeSuspended =
    (ltdPromotion ?? appSumoPromotion)?.suspended ?? false;

  const midpoint = Math.ceil(PLAN_FEATURES.length / 2);
  const columns = [
    PLAN_FEATURES.slice(0, midpoint),
    PLAN_FEATURES.slice(midpoint),
  ];

  return (
    <SettingsScrollContent>
      <RenderIf condition={isLifetimeSuspended}>
        <Alert variant="warning">
          <div className="flex flex-col">
            <div className="gap-x-1.5 flex items-center mb-1 text-xs-bold">
              Lifetime seats suspended
            </div>
            Lifetime seats are temporarily suspended while an Agency Plan is
            active. Your lifetime seats will be automatically restored when your
            Agency Plan expires.
          </div>
        </Alert>
      </RenderIf>

      <div
        className={clsx(
          "flex flex-col gap-4",
          isLifetimeSuspended && "opacity-50 pointer-events-none",
        )}
      >
        <div className="p-6.5 flex flex-col md:flex-row md:justify-between gap-6 md:gap-4 border border-black-200 rounded-5xl md:items-center bg-[url(/images/lifetime-seats-bg.webp)] bg-cover bg-center">
          <div className="flex flex-row gap-4 items-center">
            <div className="flex size-12 rounded-3xl bg-[linear-gradient(132deg,#DCE1EA_-4.58%,#FFF_85.29%)] shadow-[0_0_2px_2px_rgba(255,255,255,0.16)_inset,0_3px_6px_2px_rgba(17,24,39,0.20),0_0_0_3px_rgba(243,244,246,0.50),0_28px_20px_0_rgba(239,239,239,0.70)]">
              <FlagBannerFold weight="fill" className="size-6 m-auto" />
            </div>

            <span className="text-lg-bold">Lifetime seats</span>
          </div>

          <div className="flex flex-col md:flex-row gap-2 md:gap-4 md:mr-10">
            {columns.map((column) => (
              <div className="flex flex-col gap-2" key={column[0]}>
                {column.map((feature) => (
                  <div className="flex flex-row gap-2" key={feature}>
                    <CheckIcon className="size-4" />
                    <span className="text-xs-medium">{feature}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        <LifetimeLicenseSummary isSuspended={isLifetimeSuspended} />
      </div>

      <RenderIf condition={!isLifetimeSuspended}>
        <WorkspacesTable />
      </RenderIf>
    </SettingsScrollContent>
  );
}
